export const layout = {
  dashBoard: 'TOP',
  employees: '社員情報',
  employeesList: '個人データ登録・編集',
  idCards: 'Idカード',
  terminals: 'ターミナル',
  uniforms: 'ユニフォーム情報',
  attendanceLogs: 'マッチングデータ',
  attendanceEmployeeByDay: '日付別で表示',
  languages: '言語',
  announcements: 'メッセージ一覧',
  admins: '管理者情報',
  settings: '設定',
  exportHistory: '帳票出力履歴',
  logOut: 'ログアウト',
  clientDevice: '工程別生産性管理',
  clientDeviceByDay: '日付別で表示',
  clientDeviceByRangeDay: '期間を指定して日別で表示',
  totalClientDeviceByRangeDay: '期間を指定して集計を表示',
  attendanceEmployee: '個人別生産性管理',
  attendanceEmployeeByRangeDay: '期間を指定して日別で表示',
  attendanceTotalEmployeeByRangeDay: '期間を指定して集計を表示',
  attendance: 'データ修正、エラーチェック',
  configTime: '設定時間の作業',
  clientList: 'デバイスリスト',
  incident: 'エラーの詳細',
  deviceListError: '設備稼働履歴',
  actionAdmin: '改訂履歴',
  laundry: '洗浄',
  operator: '担当者',
  customer: '顧客',
  machine: '水洗機',
  machinePart: '機械部品',
  detergent: '洗剤',
  washingMethod: '洗浄プログラム',
  washingCount: '洗浄回数',
  notification: 'アラート',
  washingHistory: '洗浄履歴',
  washingMachinePart: '部品',
  tank: '洗剤タンク',
}
